/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import VariationOptions from '../../../Quote/Step05/components/VariationOptions'
import VariationOptionss from '../../../Quote/Step05c/components/VariationOptions'
import VariationOptionsMuseums from '../../../Quote/Step05m/components/VariationOptions'
import VariationOptionsDealers from '../../../Quote/Step05d/components/VariationOptions'

interface TradeFairLocation {
    id: number
    title: string
}

interface Props {
    fetchTradeFairsLocations: () => void
    tradeFairsLocations: {
        data: TradeFairLocation[]
    }
}

export default class CoverOptions extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            optionsOpen: true,
            tradeFairsLocList: [],
        }
    }

    componentDidMount() {
        this.props.fetchTradeFairsLocations()
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        const { tradeFairsLocations: { data: prevData = [] } } = prevProps
        const { tradeFairsLocations: { data = [] } } = this.props

        if (prevData !== data) {
            let list: { value: number; text: string }[] = []
            if (data.length > 0) {
                list = data.map((loc: TradeFairLocation) => ({
                    value: loc.id,
                    text: loc.title,
                }))
            }
            list.push({ value: 0, text: 'other' })
            this.setState({
                tradeFairsLocList: list,
            })
        }
    }

    toggleOptionsOpen = () => this.setState({ optionsOpen: !this.state.optionsOpen })

    render() {
        const { isCollectors, isMuseums, isDealersStock } = this.props

        return (
            <div
                className={
                    `mta__other quote__form mta__coverOptions quote__form__group 
                    ${(isCollectors || isMuseums || isDealersStock) ? `step5cOptions` : ``} `
                }
            >
                {(isCollectors) ?
                    <VariationOptionss
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    /> : isMuseums ? <VariationOptionsMuseums
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                    /> : isDealersStock ? <VariationOptionsDealers
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                        tradeFairsLocList={this.state.tradeFairsLocList}
                        tradeFairsLocations={this.props.tradeFairsLocations}
                    /> : <VariationOptions
                        handleAdjustChangeOptions={this.props.updateData}
                        toggleOptionsOpen={this.toggleOptionsOpen}
                        optionsOpen={this.state.optionsOpen}
                        values={this.props.data}
                        isMTA={true}
                    />
                }

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/CoverOptions.tsx